import classNames from 'classnames';
import { LabelBodyHeadline } from './LabelBodyHeadline';

type Props = {
    icon: React.ReactNode;
    text: string;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
};
export function FloatingButton({
    icon,
    text,
    onClick,
    className,
    disabled,
}: Props) {
    return (
        <button
            type="button"
            disabled={disabled}
            className={classNames(
                className,
                'inline-flex items-center rounded-full bg-white p-10',
                { 'opacity-60': disabled },
            )}
            style={{ filter: 'drop-shadow(0px 0px 10px #4D4D4D1A)' }}
            onClick={onClick}
        >
            <span className="flex aspect-square w-[44px] items-center justify-center rounded-full bg-information">
                {icon}
            </span>
            <LabelBodyHeadline className="mx-10">{text}</LabelBodyHeadline>
        </button>
    );
}
